const CategoriesPage = () => import('./index.vue')
const CreateCategory = () => import('./_pages/create_category.vue')
const CategoryEditing = () => import('./_pages/category_editing.vue')
import { AdminGuard, ManagerGuard } from '@/common/guard'

export default [
  {
    path: '/categories',
    beforeEnter: ManagerGuard,
    component: CategoriesPage,
    name: 'CategoriesIndex'
  },
  {
    path: '/categories/create',
    beforeEnter: ManagerGuard,
    component: CreateCategory,
    name: 'CreateCategory'
  },
  {
    path: '/categories/editing',
    beforeEnter: ManagerGuard,
    component: CategoryEditing,
    name: 'CategoryEditing'
  }
]
